import { fetcher } from "helpers/fetcher";

import { TCreateScorecardStaffReq, TCreateScorecardStaffRes } from "./types";
import { MANAGEMENT_ENDPOINTS } from "./endpoint";
import { API_HEADER } from "api/constants";

export const createScorecardStaff = async (
  payload: TCreateScorecardStaffReq
) => {
  return await fetcher<
    TCreateScorecardStaffRes,
    TCreateScorecardStaffReq["data"]
  >(MANAGEMENT_ENDPOINTS.CREATE_SCORECARD_STAFF, {
    headers: {
      [API_HEADER.BU_ID]: payload.idBu,
    },
    data: payload.data,
  });
};

export const mutationCreateScorecardStaff = async (
  payload: TCreateScorecardStaffReq
) => {
  return (await createScorecardStaff(payload)).data;
};

mutationCreateScorecardStaff._key = (payload: TCreateScorecardStaffReq) => [
  MANAGEMENT_ENDPOINTS.CREATE_SCORECARD_STAFF.url,
  payload,
];
